import { useEffect, useState } from 'react';
import { BREAKPOINTS } from '@/theme/palette';

const read = () => (typeof window === 'undefined' ? 1440 : window.innerWidth);

/** The viewport width, updated on resize and rotation. */
export const useViewportWidth = (): number => {
  const [width, setWidth] = useState(read);
  useEffect(() => {
    const update = () => setWidth(read());
    window.addEventListener('resize', update);
    window.visualViewport?.addEventListener('resize', update);
    return () => {
      window.removeEventListener('resize', update);
      window.visualViewport?.removeEventListener('resize', update);
    };
  }, []);
  return width;
};

/** The spec §2 breakpoints as flags; each one applies below its width, cumulatively. */
export const useBreakpoints = () => {
  const width = useViewportWidth();
  return {
    width,
    compact: width < BREAKPOINTS.compact,
    narrow: width < BREAKPOINTS.narrow,
    medium: width < BREAKPOINTS.medium,
    shortTabs: width < BREAKPOINTS.tabs,
    treeDrawer: width < BREAKPOINTS.tree,
    sourceModal: width < BREAKPOINTS.dock,
  };
};
